export const tjtEditions = [
  { name: "South Africa", publicationName: "The Johannesburg Times", prefix: null, preferenceCode: "za", countryCode: "ZA", image: "sa.png" },
  { name: "Botswana", publicationName: "The Johannesburg Times Botswana", prefix: "bw", preferenceCode: "bw", countryCode: "BW", image: "Botswana.png" },
  { name: "Zimbabwe", publicationName: "The Johannesburg Times Zimbabwe", prefix: "zw", preferenceCode: "zw", countryCode: "ZW", image: "Zimbabwe.png" },
  { name: "Kenya", publicationName: "The Johannesburg Times Kenya", prefix: "ke", preferenceCode: "ke", countryCode: "KE", image: "Kenya.png" },
  { name: "Nigeria", publicationName: "The Johannesburg Times Nigeria", prefix: "ng", preferenceCode: "ng", countryCode: "NG", image: "Nigeria.png" }
];

export function getOtherTjtEditions(activePrefix) {
  const normalizedPrefix = activePrefix || null;
  const activeEdition = tjtEditions.find((edition) => edition.prefix === normalizedPrefix) || tjtEditions[0];
  return tjtEditions.filter((edition) => edition.preferenceCode !== activeEdition.preferenceCode);
}
